module.exports = __webpack_public_path__ + "static/img/iotG.2ddef63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/iotG.jpg
// module id = 6xHT
// module chunks = 0